<template>
  <el-popover placement="right" width="248" v-model="show" trigger="click">
    <div class="popover">
      <div class="list-container">
        <div
          class="type-container"
          v-for="typeList in list"
          :key="typeList.title"
        >
          <div class="type-title">
            {{ typeList.title }}
          </div>
          <div
            class="list-item"
            :key="item.image"
            v-for="item in typeList.items"
          >
            <div class="image" v-lazy:background-image="item.image">
              <div v-if="item.socialNetwork === 1" class="ins-user-icon"></div>
              <div
                v-if="item.socialNetwork === 2"
                class="fb-page-user-icon"
              ></div>
              <div
                v-if="item.socialNetwork === 3"
                class="fb-group-user-icon"
              ></div>
              <div v-if="item.socialNetwork === 4" class="tw-user-icon"></div>
              <div class="right-container">
                <div class="username-text">{{ item.username }}</div>
                <!-- <div class="des-text">{{item.description}}</div> -->
              </div>
              <div class="button-container">
                <div
                  class="remove-btn"
                  v-show="hasOne"
                  @click="removeClick(item)"
                >
                  {{ $t("common.remove") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="reference" style="height: 20px">
      <slot></slot>
    </div>
  </el-popover>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.popover {
  .list-container {
    max-height: 400px;
    overflow: auto;
  }
  .type-container {
    border-bottom: 1px solid #e6e6e6;
    &:last-child {
      border-bottom-width: 0;
    }
    .type-title {
      font-size: 16px;
      padding: 15px;
      color: #000000;
      font-weight: 600;
    }
    .list-item {
      display: flex;
      padding: 0 15px;
      margin-bottom: 15px;
      .image {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-position: center;
        background-size: contain;
        position: relative;
      }
      .right-container {
        padding: 0 10px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        .username-text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: start;
          white-space: nowrap;
        }
        .des-text {
          font-size: 13px;
          color: @font-color-gray;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .button-container {
        display: flex;
        align-items: center;
        justify-items: right;
        .remove-btn {
          font-size: 14px;
          color: #5a5a5a;
          cursor: pointer;
          &:hover,
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";
import { linkedInstagramTypes } from "../../../const/plan";
import _ from "lodash";

export default {
  name: "TeamMemberInstagramPopoverComponent",
  data() {
    return {
      show: false,
    };
  },
  props: {
    member: {
      type: Object,
    },
  },
  methods: {
    removeClick(item) {
      this.show = false;
      this.$emit("remove", {
        id: this.member.id,
        publisherId: item.publisherId,
      });
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 是否至少存在一个
     */
    hasOne() {
      return this.member.publishers.length > 1;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      // 根据类型进行分组
      let types = [];
      const limitedPublishers = _.cloneDeep(this.member.publishers).filter(
        (l) => !l.isUnlimited
      );
      const unlimitedPublishers = _.cloneDeep(this.member.publishers).filter(
        (l) => l.isUnlimited
      );
      if (unlimitedPublishers.length > 0) {
        types.push({
          title: linkedInstagramTypes[1].text,
          items: unlimitedPublishers,
        });
      }
      if (limitedPublishers.length > 0) {
        types.push({
          title: linkedInstagramTypes[0].text,
          items: limitedPublishers,
        });
      }
      return types;
    },
  },
};
</script>
